<script>
/***************************************************************
 * File                                                        *
 * --------------------                                        *
 * control element for uploading CSV files                     *
 ***************************************************************/

   export let id;             // text ID for file input
   export let file = null;    // container to get return the uploaded file

   let fileInput;

   function changeStatus(e) {
      if (fileInput.files.length > 0) {
         file = fileInput.files[0];
      }
   }
</script>

<label class:selected="{file !== null}">
   { file ? file.name : "Select CSV file with dataset" }
   <input on:change={changeStatus} bind:this={fileInput} name={id} type="file" accept=".csv">
</label>

<style>
   input {
      display: none;
   }

   label {
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      flex: 1 1;
      min-width: 0;
   }

   label::before {
      display: inline-block;
      content: '\21ea';
      font-size: 1.2em;
      margin: 0 0.5em 0 0em;
   }

   label.selected {
      color: #909090;
   }

   label.selected::before {
      content: '\28FF\28FF';
      letter-spacing: -.25em;
      color: #6EB8FF;
      font-weight: bold;
   }
</style>